import CityForm from "./Form/Form"
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <CityForm></CityForm>
    </div>
  );
}

export default App;
